import React, {useEffect, useState} from 'react';
import {MenuLateralAA} from '../menuLateralAA/MenuLateralAA';
import {Cuidador} from './Cuidador';
import {ListaUsu} from './ListaUsu';
import {FormularioCuidadores} from './FormularioCuidadores';
import Switch from 'react-switch';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ContentBodyCuidadores = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* A hook that is used to store the state of the component. */
	const [ListaUsuarios, setListaUsuarios] = useState(ListaUsu());

	/* A hook that is used to store the state of the component. */
	const [PantallaPeril, setPantallaPerfil] = useState(false);

	const [DataForm, setDataForm] = useState({
		nombre: '',
		id: '',
	});

	/* A hook that is used to store the state of the component. */
	const [UsuarioFiltro, setUsuarioFiltro] = useState({
		nombre: '',
		telefono: '',
		ID: '',
	});

	/**
	 * When the input changes, set the UsuarioFiltro state to the current value of the input.
	 */
	const onInputChange = (event) => {
		setUsuarioFiltro({
			...UsuarioFiltro,
			[event.target.name]: event.target.value,
		});
	};

	/* A hook that is used to store the state of the component. */
	useEffect(() => {
		setListaUsuarios(ListaUsu());
	}, []);

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const abrirPerfil = (idUsuario, nombreUsuario) => {
		setDataForm({
			nombre: nombreUsuario,
			id: idUsuario,
		});
		setPantallaPerfil(true);
	};

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const anadirUsuarios = () => {
		setPantallaPerfil(true);
	};

	return (
		<div className='ContentUsuarios'>
			{/* Esta es la posicon del boton qu se ha de estar seleccionado*/}
			{
				<MenuLateralAB
					seleccionado={4}
					MenuLateralAux={MenuLateralAux}
					chageMenuLateralAux={chageMenuLateralAux}
				/>
			}
			{PantallaPeril === false ? (
				<div className='derContentUsusaios'>
					<div className='headContentUsuarios'>
						<div className='superiorHeadContentUsuarios'>
							<div>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='40'
									height='40'
									fill='currentColor'
									className='bi bi-heart-pulse-fill'
									viewBox='0 0 16 16'
								>
									<path
										fillRule='evenodd'
										d='M1.475 9C2.702 10.84 4.779 12.871 8 15c3.221-2.129 5.298-4.16 6.525-6H12a.5.5 0 0 1-.464-.314l-1.457-3.642-1.598 5.593a.5.5 0 0 1-.945.049L5.889 6.568l-1.473 2.21A.5.5 0 0 1 4 9H1.475ZM.879 8C-2.426 1.68 4.41-2 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C11.59-2 18.426 1.68 15.12 8h-2.783l-1.874-4.686a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.88Z'
									/>
								</svg>
							</div>
							<div className='centrador titleHeadHistorialFacturas'>Cuidadores</div>
						</div>
						<div className='separador'></div>
						<div className='inferiorHeadContentUsuarios'>
							<div className='derHeadContentUsuarios'>
								<div className='inputHeadContentUsuarios'>
									<div className='labelInputUsuarios'>Nombre</div>
									<div className='inputUsuario'>
										<input
											className='inputTextUsuario'
											name='nombre'
											type='text'
											value={UsuarioFiltro.nombre}
											onChange={onInputChange}
										/>
									</div>
								</div>
								<div className='inputHeadContentUsuarios'>
									<div className='labelInputUsuarios'>Teléfono</div>
									<div className='inputUsuario'>
										<input
											className='inputTextUsuario'
											name='telefono'
											type='text'
											value={UsuarioFiltro.telefono}
											onChange={onInputChange}
										/>
									</div>
								</div>
								<div className='inputHeadContentUsuarios'>
									<div className='labelInputUsuarios'>ID</div>
									<div className='inputUsuario'>
										<input
											className='inputTextUsuario'
											name='ID'
											type='text'
											value={UsuarioFiltro.ID}
											onChange={onInputChange}
										/>
									</div>
								</div>
							</div>
							<div className='izqheadContentUsuarios centrador'>
								<div
									className='buttonAddUsuarios'
									onClick={anadirUsuarios}
								>
									<div className='centrador'>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='16'
											height='16'
											fill='currentColor'
											className='bi bi-plus-circle-fill'
											viewBox='0 0 16 16'
										>
											<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
										</svg>
									</div>
									<div className='centrador'>Añadir Cuidador</div>
								</div>
							</div>
						</div>
					</div>
					<div className='lista-cuidadores'>
						{ListaUsuarios.map((usuario, id) =>
							usuario.nombreUsuario
								.toLowerCase()
								.includes(UsuarioFiltro.nombre.toLowerCase()) &&
							(usuario.telefonoUsuario.includes(UsuarioFiltro.telefono) ||
								usuario.telefonoUsuario2.includes(UsuarioFiltro.telefono)) &&
							usuario.idUsuario.includes(UsuarioFiltro.ID) ? (
								<Cuidador
									key={id}
									fotPantallaPerileccionUsuario={usuario.direccionUsuario}
									nombreUsuario={usuario.nombreUsuario}
									idUsuario={usuario.idUsuario}
									direccionUsuario={usuario.direccionUsuario}
									telefonoUsuario={usuario.telefonoUsuario}
									correoUsuario={usuario.correoUsuario}
									telefonoUsuario2={usuario.telefonoUsuario2}
									abrirPerfil={abrirPerfil}
								/>
							) : null
						)}
					</div>
				</div>
			) : (
				<FormularioCuidadores
					setPantallaPerfil={setPantallaPerfil}
					DataForm={DataForm}
				/>
			)}
		</div>
	);
};
/*
usuarios:
    info tarjetas:
        - nombre correo telefono 
    form :
        - contrase correo ... ( lo que hay en mi perfil )

pacientes:
    info tarjeta: 
        - nombre y apellidos
        - direcion
        - localicadad
        - cod postal
        - telefono corroceo
        - sharecare
    form:
        - numero cuenta
cuidadore: 
    info:
        - nombre, apellido localidad, telfono, estado si esta trabajando   
    form :
        - ratio
*/
